import { TranslationKey } from "@/modules/i18n"
import { ChallengeService } from "@duck/api-definitions"
import { AssignmentTab } from "./WorkspaceTabs/Assignment/Assignment.tab"
import { SolutionTab } from "./WorkspaceTabs/Solution/Solution.tab"
import { SqlTab } from "./WorkspaceTabs/Sql/Sql.tab"
import { NotesTab } from "./WorkspaceTabs/Notes/Notes.tab"
import { SqlCheatSheetTab } from "./WorkspaceTabs/SqlCheatSheet/SqlCheatSheet.tab"
import { SchemaTab } from "./WorkspaceTabs/Schema/Schema.tab"
import { TipsHistoryTab } from "./WorkspaceTabs/TipsHistory/TipsHistory.tab"

export type WorkspaceTabComponentProps = {
  data?: string
  onUpdateData?: (data: string) => void
  isVisible?: boolean
}
import { FC } from "react"

export type WorkspaceTabsItem = {
  label: TranslationKey
  Component: FC<WorkspaceTabComponentProps>
  onlyOne?: boolean
  /** If true, this tab's content is rendered as a portal singleton at the WorkspaceTabs level, surviving view remounts. */
  portalSingleton?: boolean
}

const AssignmentTabWrapper: FC<WorkspaceTabComponentProps> = () => <AssignmentTab />

const SolutionTabWrapper: FC<WorkspaceTabComponentProps> = () => <SolutionTab />

const NotesTabWrapper: FC<WorkspaceTabComponentProps> = () => <NotesTab />

const SqlTabWrapper: FC<WorkspaceTabComponentProps> = ({ data, onUpdateData, isVisible }) => (
  <SqlTab query={data} onUpdateData={onUpdateData} isVisible={isVisible} />
)

const SqlCheatSheetTabWrapper: FC<WorkspaceTabComponentProps> = () => <SqlCheatSheetTab />

const SchemaTabWrapper: FC<WorkspaceTabComponentProps> = () => <SchemaTab />

const TipsHistoryTabWrapper: FC<WorkspaceTabComponentProps> = () => <TipsHistoryTab />

export const workspaceTabsDefinitions: Record<ChallengeService.WorkspaceTabTypeEnum, WorkspaceTabsItem> = {
  [ChallengeService.WorkspaceTabTypeEnum.Assignment]: {
    label: "common.assignment",
    Component: AssignmentTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Solution]: {
    label: "common.solution",
    Component: SolutionTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Sql]: {
    label: "common.sql",
    Component: SqlTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Notes]: {
    label: "common.notes",
    Component: NotesTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.SqlCheatSheet]: {
    label: "common.sqlCheatSheet",
    Component: SqlCheatSheetTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Schema]: {
    label: "challenges.schema",
    Component: SchemaTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.TipsHistory]: {
    label: "challenges.tipsHistory",
    Component: TipsHistoryTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Python]: {
    label: 'common.python',
    onlyOne: true,
    portalSingleton: true,
    Component: () => null,
  }
}

export const workspaceTabsOrder: ChallengeService.WorkspaceTabTypeEnum[] = [
  ChallengeService.WorkspaceTabTypeEnum.Assignment,
  ChallengeService.WorkspaceTabTypeEnum.Sql,
  ChallengeService.WorkspaceTabTypeEnum.Schema,
  ChallengeService.WorkspaceTabTypeEnum.Solution,
  ChallengeService.WorkspaceTabTypeEnum.Notes,
  ChallengeService.WorkspaceTabTypeEnum.SqlCheatSheet,
  ChallengeService.WorkspaceTabTypeEnum.TipsHistory,
  ChallengeService.WorkspaceTabTypeEnum.Python,
]
